import React from 'react'
import MenuButton from 'components/Button/MenuButton'
import { COMPONENT_TYPES } from 'helpers/utils/constants'
import {
  DeleteForever,
  Edit,
  ManageAccounts,
  Settings,
} from "@mui/icons-material";

const LabProgramMenuItem = ({ labP, navigateMemberManagement, navigateEditLP, setOpenConfirmationModal, t}) => {
  return (
    <div>
        <MenuButton
            listWithTitleonClick={[
            {
                title: "Manage Members",
                onClick: () =>
                navigateMemberManagement(
                    COMPONENT_TYPES.LAB_PROGRAMS,
                    labP?.slug
                ),
                icon: ManageAccounts,
                iconClasses: "c-primary",
            },
            {
                divider: true,
            },
            {
                title: "Edit",
                onClick: () => navigateEditLP(labP?.slug),
                icon: Edit,
            },
            {
                title: "Delete",
                onClick: () => setOpenConfirmationModal(labP?.slug),
                icon: DeleteForever,
                iconClasses: "c-error",
                classes: "c-error",
            },
            ]}
            classes="fs-1 fs-13"
            height="30px"
            bordered
        >
            <Settings fontSize="small" /> {t("Manage", "common")}
        </MenuButton>

    </div>
  )
}

export default LabProgramMenuItem